import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CacheService } from '@se/se.ui.html5';
import { Observable, from } from 'rxjs';


export const ESTENSA_MODULE_SPECIALIZED_CLIENT_APPLICATION_SETTINGS_SERVICE = new InjectionToken('estensa.module.specialized.application.settings.service');

@Injectable({
    providedIn: 'root',
})
export class SpecializedClientApplicationSettingsService {

    constructor(@Inject(ESTENSA_MODULE_SPECIALIZED_CLIENT_APPLICATION_SETTINGS_SERVICE) private settingsService,
                private cacheService: CacheService) { }

    getSettings(): Observable<any> {
        return this.cacheService.get(
            'SpecializedClientApplicationSettings',
            from(this.settingsService.getAsJSON()),
        );
    }
}
